import { useParams } from 'react-router-dom';
import DashboardBreadcrumbs from 'domain/projects/newProject/shared/breadcrumbs/DashboardBreadcrumbs';
import { ListBreadcrumbItem } from 'framework/ui/BreadCrumbs';
import { RisksType, useNewProjectUrl } from 'domain/shared/newProject';
import { EMPTY_VALUE_INDICATOR } from 'framework/utils';

const RiskBreadcrumbs = ({ risk, projectName }: { risk: RisksType; projectName?: string }) => {
  const { id, riskId } = useParams();
  const { getRisksUrl } = useNewProjectUrl();

  return (
    <DashboardBreadcrumbs>
      <ListBreadcrumbItem entity={projectName || EMPTY_VALUE_INDICATOR} link={getRisksUrl(id!)} />
      <ListBreadcrumbItem entity={risk?.alias ?? risk?.id} link={getRisksUrl(riskId)} />
    </DashboardBreadcrumbs>
  );
};
export default RiskBreadcrumbs;
